<template>
  <div id="app" class="flex flex-col h-full" :class="{'overflow-hidden': modalOpen}">
    <Navigation />
    <main class="flex-grow">
      <transition name="fade" mode="out-in">
        <router-view />
      </transition>
      <cookie-law theme="dark-lime" 
                  :button-text="'Понятно'" 
                  :message="'Этот веб-сайт использует файлы cookie, чтобы вы могли максимально эффективно использовать наш веб-сайт.'"></cookie-law>
    </main>
    <MyFooter />
    <transition name="fade">
      <Modal v-if="modalOpen"/>
    </transition>
  </div>
</template>
<script>
// @ is an alias to /src
import Navigation from "@/components/Navigation.vue";
import MyFooter from "@/components/MyFooter.vue";
import Modal from "@/components/Modal.vue";
import CookieLaw from 'vue-cookie-law'

export default {
  components: {
    Navigation,
    MyFooter,
    Modal,
    CookieLaw
  },
   computed: {
    modalOpen() {
      return this.$store.state.isModalOpen;
    }
  },
};
</script>


<style lang="scss">
html {
  font-family: "Roboto", sans-serif !important;
  height: 100%;
}

body {
  height: 100%;
  background-color: rgba(0, 0, 0, 0.05);
}
.fade-enter-active,
.fade-leave-active {
  transition-duration: 0.3s;
  transition-property: opacity;
  transition-timing-function: ease;
}

.fade-enter,
.fade-leave-active {
  opacity: 0;
}
</style>
